import { h, Component } from 'preact'
import style from './styles/input.scss'

import Icon from '../Icon'

const mixValues = (src, placeholder, edge) => src.slice(0, edge) + placeholder.slice(edge)

function makeMask(src) {
  const hasLast = (mask) => mask.length > 0
  const lastRange = (mask) => mask[mask.length - 1]
  const isUnderscore = (index) => src[index] === '_'
  const isContinued = (index, mask) => hasLast(mask) ?
    lastRange(mask)[1] === index : false
  const growMask = (mask, index) => {
    if (index < src.length) {
      if (isUnderscore(index)) {
        if (isContinued(index, mask)) {
          const last = lastRange(mask)
          last[1] = index + 1
          return growMask(mask, index + 1)
        } else {
          return growMask(mask.concat([[index, index + 1]]), index + 1)
        }
      } else {
        return growMask(mask, index + 1)
      }
    }
    return mask
  }
  return growMask([], 0)
}

const goForward = (mask, cursor, range = 0) => {
  if (range < mask.length) {
    return cursor < mask[range][0] ? mask[range][0]
      : cursor < mask[range][1] ? cursor
      : goForward(mask, cursor, range + 1)
  }
  return mask[mask.length - 1][1]
}

const goBack = (mask, cursor, range = mask.length - 1) => {
  if (range >= 0) {
    return cursor > mask[range][1] ? mask[range][1]
    : cursor > mask[range][0] ? cursor
    : goBack(mask, cursor, range - 1)
  }
  return mask[0][0]
}

const isCorrectPos = (mask, cursor, range = 0) => {
  if (range < mask.length) {
    return cursor >= mask[range][0] && cursor < mask[range][1] ?
      true : isCorrectPos(mask, cursor, range + 1)
  }
  return false
}

const phonePlaceholder = '+7 (___) ___-__-__'
const phoneMask = makeMask(phonePlaceholder)

class Input extends Component {
  saveRef = ref => this.input = ref

  constructor(props) {
    super(props)
    this.state = {
      cursor: 0,
      value: props.format === 'tel' ? phonePlaceholder : ''
    }
  }

  componentDidMount() {
    const {format} = this.props
    this.input.focus()
    if (format === 'tel') {
      const cursor = goForward(phoneMask, 0)
      this.input.setSelectionRange(cursor, cursor)
      this.setState({cursor})
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {format} = this.props
    if (format === 'tel') {
      const {cursor} = this.state
      this.input.setSelectionRange(cursor, cursor)
    }
  }

  handleSubmit = (event) => {
    event.preventDefault()

    const {onSubmit} = this.props
    onSubmit(this.state.value)
  }

  handleChange = ({target}) => {
    const {format} = this.props
    if (format === 'tel') {
      this.parseTelValue(target.value)
    } else {
      this.setState({value: target.value})
    }
  }

  parseTelValue(inputValue) {
    const {selectionEnd} = this.input
    const {cursor} = this.state
    const value = mixValues(inputValue, phonePlaceholder, selectionEnd)
    const lastChar = inputValue.slice(selectionEnd - 1, selectionEnd)
    const isForward = selectionEnd >= cursor
    const nextCursor = isForward ? goForward(phoneMask, selectionEnd)
      : goBack(phoneMask, selectionEnd)
    if (lastChar.match(/[0-9]/)) {
      if (isCorrectPos(phoneMask, selectionEnd - 1)) {
        this.setState({
          value: value.slice(0, phonePlaceholder.length),
          cursor: nextCursor
        })
      } else {
        this.setState(prev => {
          const correctInput = prev.value.slice(0, nextCursor).concat(lastChar)
          const value = mixValues(correctInput, phonePlaceholder, nextCursor + 1)
          return {
            value: value.slice(0, phonePlaceholder.length),
            cursor: goForward(phoneMask, nextCursor + 1)
          }
        })
      }
    } else if (selectionEnd >= cursor) {
      this.setState(prev => {
        value: prev.value
        cursor: prev.cursor
      })
    } else {
      this.setState({value, cursor: nextCursor})
    }
  }

  handleSkip = (event) => {
    event.preventDefault()
    const {onSubmit} = this.props
    onSubmit(this.state.value)
  }

  render ({format, placeholder}, {value}) {
    const hasNo = !!value.toLowerCase().match(/нет/)
    const showSkip = format === 'email' && hasNo
    return (
      <form
        class={format === 'tel' ? style.phone : style.form}
        action="#"
        onSubmit={this.handleSubmit}
        style={{
          flexWrap: showSkip ? 'wrap' : 'nowrap'
        }}
      >
        <input
          ref={this.saveRef}
          class={style.input}
          type={format}
          onInput={this.handleChange}
          value={value}
          autoFocus
          required="required"
          placeholder={placeholder}
          style={{
            marginBottom: showSkip ? 10 : 0
          }}
        />
        <button class={style.button}>Отправить</button>
        {showSkip && <button class={style.skip} onClick={this.handleSkip}>
          Пропустить
        </button>}
      </form>
    )
  }
}

export default Input



// WEBPACK FOOTER //
// ./components/forms/Input.js